<script lang="ts">
    import Header from "../../components/Header.svelte";
    import WidthBox from "../../components/WidthBox.svelte";
    import Course from "../../components/Course.svelte";
    import Module from "../../components/Module.svelte";
    import { t } from "@lernetz/svelte-translate";
    import { setupSharedProps } from "../../services";

    export let courses;

    setupSharedProps();

</script>

<Header title={"modules"} />
<WidthBox>
    <div class="mt-112">
        <div class="text-almost-black text-16">{$t("choose-module")}</div>
        <div class="mt-32 grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-16 sm:gap-24 content-center">
            {#each courses as course}
                <Course course={course} />
            {/each}
        </div>
    </div>
</WidthBox>
